/**
 * PostsCarousel Component
 *
 * Horizontal carousel of blog post cards.
 * Accepts pre-normalized PostCardData[] — normalization happens
 * in the parent page (composition root), not here.
 */
import type { PostCardData } from '@/shared/lib/types/content';
import type { Route } from '@letsgethome/routes';
import type { LocalizedText } from '@letsgethome/types/branded';
import { CarouselItem } from '@letsgethome/ui/carousel';

import { PostCard } from './PostCard';
import { PostsCarouselClient } from './PostsCarouselClient';

interface PostsCarouselProps {
  /** Section title — must come from `t()` or `plainText()` (no raw literal). */
  title: LocalizedText;
  /** Optional href - title becomes clickable link with chevron */
  seeAllHref?: Route;
  /** Pre-normalized post data (normalized in page, not here) */
  posts: PostCardData[];
}

export function PostsCarousel({ title, seeAllHref, posts }: PostsCarouselProps) {
  if (posts.length === 0) {
    return null;
  }

  return (
    <section className="w-full">
      <PostsCarouselClient title={title} seeAllHref={seeAllHref}>
        {posts.map((post) => (
          <CarouselItem
            key={post.id}
            className="pl-4 basis-[280px] sm:basis-[300px] lg:basis-[320px]"
          >
            <PostCard post={post} variant="compact" sizes="320px" />
          </CarouselItem>
        ))}
      </PostsCarouselClient>
    </section>
  );
}
